import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, History, User, LogOut } from 'lucide-react';
import { useAuth } from '@features/auth/hooks/useAuth';
import { NotificationBell } from '@components/common/NotificationBell';
import { cn } from '@lib/utils';

const navItems = [
  { path: '/portal/dashboard', label: 'Inicio', icon: LayoutDashboard },
  { path: '/portal/historial', label: 'Historial', icon: History },
  { path: '/portal/perfil', label: 'Mi Perfil', icon: User },
];

export function ClientLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="sticky top-0 z-30 border-b border-gray-100 bg-white shadow-sm">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 lg:px-8">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="/logo-merino.png"
              alt="Merino Control de Plagas"
              className="h-10 w-auto object-contain"
            />
          </div>

          {/* Navigation */}
          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-merino-100 text-merino-700'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )
                }
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* User menu */}
          <div className="flex items-center gap-2">
            <NotificationBell />
            <div className="hidden text-right md:block">
              <p className="text-sm font-medium text-gray-900">{user?.nombre}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
              title="Cerrar sesión"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>

        {/* Mobile navigation */}
        <nav className="flex border-t border-gray-100 md:hidden">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                cn(
                  'flex flex-1 flex-col items-center gap-1 py-2 text-xs transition-colors',
                  isActive
                    ? 'bg-merino-50 text-merino-700'
                    : 'text-gray-600 hover:bg-gray-50'
                )
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Main content */}
      <main className="mx-auto max-w-7xl px-4 py-8 lg:px-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 bg-white py-6 text-center text-sm text-gray-500">
        <p>© 2025 Merino Control de Plagas. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

